import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { FormGeneratorComponent } from './form-generator/form-generator.component';
import { TextInputComponent } from './form-element/text-input/text-input.component';
import { TextLabelComponent } from './form-element/text-label/text-label.component';
import { PrimaryBtnComponent } from './form-element/primary-btn/primary-btn.component';
import { CheckboxComponent } from './form-element/checkbox/checkbox.component';
import { SelectListComponent } from './form-element/select-list/select-list.component';
import { NumberInputComponent } from './form-element/number-input/number-input.component';
import { RadioBtnComponent } from './form-element/radio-btn/radio-btn.component';
import { DatePickerComponent } from './form-element/date-picker/date-picker.component';
import { TextAreaComponent } from './form-element/text-area/text-area.component';
import { RadioSwitchComponent } from './form-element/radio-switch/radio-switch.component';
import { TooltipComponent } from './form-element/tooltip/tooltip.component';
import { TooltipDirective } from '../shared/tooltip.directive';
import { InputTextModule } from '@tmhcc-ng-lib/framwork/form-inputs';

@NgModule({
  declarations: [
    FormGeneratorComponent,
    TextInputComponent,
    TextLabelComponent,
    PrimaryBtnComponent,
    CheckboxComponent,
    SelectListComponent,
    NumberInputComponent,
    RadioBtnComponent,
    DatePickerComponent,
    TextAreaComponent,
    RadioSwitchComponent,
    TooltipComponent,
    TooltipDirective
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InputTextModule,
    BsDatepickerModule.forRoot()
  ],
  exports: [
    TextLabelComponent,
    FormGeneratorComponent,
    TextInputComponent,
    DatePickerComponent,
    SelectListComponent,
    NumberInputComponent,
    RadioBtnComponent,
    TextAreaComponent,
    RadioSwitchComponent,
    CheckboxComponent,
    TooltipComponent
  ]
})
export class LibModuleModule {}
